import { useContext } from "react";
import { getUserPermissions } from "../permissions";
import { AuthContext } from "../AuthContext";

export function usePermissions() {
  const { userData } = useContext(AuthContext);

  const groups = userData?.userGroups || [];
  const permissions = getUserPermissions(groups);

  const hasPermission = (perm) => Boolean(permissions[perm]);

  const denyMessage = (perm) => {
    if (hasPermission(perm)) return "";
    const groupList = groups.length ? groups.join(", ") : "your";
    return `As part of the ${groupList} group, you are not authorized to perform this action.`;
  };

  return { permissions, groups, hasPermission, denyMessage };
}


// ⭐ Add RequirePermission here as a NAMED export
export function RequirePermission({
  permission,
  children,
  fallback,
  showMessage = false
}) {
  const { hasPermission, denyMessage } = usePermissions();

  if (!hasPermission(permission)) {
    if (fallback) return fallback;

    if (showMessage) {
      return (
        <div style={{ color: "#b00", marginTop: "8px" }}>
          {denyMessage(permission)}
        </div>
      );
    }

    // If showMessage = false → render nothing
    return null;
  }

  return children;
}
